import {BlockType, Blocks} from '../blocks/Blocks'
import {
	Contentside,
	ContentsideContent,
	ContentsideFixed,
	ContentsideSidebar
} from '../layout/Contentside'
import {CtaRegister, CtaRegisterType} from '../layout/cta/CtaRegister'
import {Hero, HeroSide, HeroType} from '../layout/Hero'
import {Infoshare, InfoshareType} from '../layout/Infoshare'
import {Participants, ParticipantsType} from '../layout/Participants'
import {SidebarBlockType, SidebarBlocks} from '../sidebar/SidebarBlocks'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Layout} from '../layout/Layout'
import {PageData} from '../../types'
import React from 'react'
import {RelatedEvents} from '../layout/RelatedEvents'
import {getUrlByKey} from '../../util/nav'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('edition')

type EditionType = {
	hero: HeroType
	contentblocks?: Array<BlockType>
	sidebarblocks?: Array<SidebarBlockType>
	blocks?: Array<BlockType>
	teamsOverviewLink?: string
	participants: ParticipantsType
	numberOfTeams: number
	totalAmount: number
} & InfoshareType &
	CtaRegisterType

export const Edition: React.FC<PageData & EditionType> = wrap(Layout)(
	({...props}) => {
		const {
			parents,
			title,
			hero,
			date,
			location,
			registration,
			contentblocks,
			sidebarblocks,
			blocks,
			teamsOverviewLink,
			participants,
			numberOfTeams,
			totalAmount,
			related_project,
			related_events,
			main_pages
		} = props
		const eventsLink = getUrlByKey(main_pages, 'events')

		return (
			<div className={styles()}>
				{hero?.image && (
					<Hero {...hero} title={(hero && hero.title) || title} />
				)}
				<Breadcrumbs parents={parents} title={title} />
				<Contentside>
					<ContentsideContent>
						<ContentsideFixed>
							{(!hero || !hero?.image) && (
								<HeroSide {...hero} title={hero?.title || title} />
							)}
							<Infoshare date={date} location={location} />
							<Participants
								totalAmount={totalAmount}
								participants={participants}
								teamsOverviewLink={teamsOverviewLink}
								numberOfTeams={numberOfTeams}
							/>
							<CtaRegister {...registration} />
						</ContentsideFixed>
						<Blocks blocks={contentblocks} />
					</ContentsideContent>
					<ContentsideSidebar>
						<SidebarBlocks blocks={sidebarblocks} />
					</ContentsideSidebar>
				</Contentside>
				<Blocks blocks={blocks} container={true} />
				<RelatedEvents
					linkToEventspage={eventsLink?.url}
					project={related_project}
					events={related_events}
				/>
			</div>
		)
	}
)
